// App.js
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import { trackPageView } from './analytics';
import RankingPerState from './rankingPerState'; // Import the Component1
import RankingPerScore from "./rankingPerScore";
import RankingPersonalDetails from "./rankingPersonalDetails";
import MainPage from "./mainPage";
import AppointmentDate from "./restComponents";
import RankingAboveMe from "./peopleAboveMe";
import RentPrices from "./rentPrices";
import Login from './loginPage';
import Register from './registerPage';
import HistoricalData from './historicalData';
import TransferData from './transferData';
import ContactSupport from './contactSupport';
import TermsOfUse from './termsOfUse';
import PrivacyPolicy from './privacyPolicy';
import ForgotUsername from './forgotUsername';
import ForgotPassword from './forgotPassword';
import ResetPassword from './resetPassword';
import UnderConstructionPage from './underConstructionPage';
import HistoricalDataAppointments from './historicalDataAppointments';
import NonReachablePlaces from './nonReachablePlaces';
import Predict from './predict';
import PredictMethodology from './predictMethodology';
import PremiumUpgrade from './premiumUpgrade';
import DonationSuccess from './donationSuccess';
import TermsAcceptanceGate from './TermsAcceptanceGate';
import { getHost, isUnderConstruction } from './config';
import './custom.scss';



const refreshAuthToken = async() => {
    try {
        const token = localStorage.getItem('authToken');
        const url = `${getHost()}/api/refresh`
        if (!token) return;

        const response = await fetch(url, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({ refresh_token: localStorage.getItem('refreshToken') })
          });

          const data = await response.json();
          localStorage.setItem('authToken', data.token);
    } catch (error) {
        console.error("Error refreshing token", error);
    }
};


function AppWithNavigate() {
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        trackPageView(location.pathname + location.search, document.title);
    }, [location.pathname, location.search]);

    useEffect(() => {
        const intervalId = setInterval(() => {
            refreshAuthToken();
        }, 30 * 60 * 1000);

        return () => clearInterval(intervalId);
    }, []);

    useEffect(() => {
        const onStorageChange = (e) => {
        if (e.key === 'logout-event') {
            localStorage.removeItem('authToken');
            navigate('/', { replace: true }); // or use window.location.href = '/' if outside React Router
        }
        };

        window.addEventListener('storage', onStorageChange);
        return () => window.removeEventListener('storage', onStorageChange);
    }, [navigate]);

    if (isUnderConstruction()) {
        return (
            <Routes>
                <Route path="*" element={<UnderConstructionPage />} />
            </Routes>
        );
    }

    return (
            <TermsAcceptanceGate>
            <Routes>
                <Route exact path="/" element={<Login />} /> {/* Route for page 1 */}
                <Route exact path="/register" element={<Register />} /> {/* Route for page 1 */}
                <Route exact path="/main" element={<MainPage />} /> {/* Route for page 1 */}
                <Route exact path="/ranking-per-state" element={<RankingPerState />} /> {/* Route for page 1 */}
                <Route exact path="/appointment-date" element={<AppointmentDate />} /> {/* Route for page 1 */}
                <Route exact path="/ranking-per-score" element={<RankingPerScore />} /> {/* Route for page 1 */}
                <Route exact path="/ranking-personal-details" element={<RankingPersonalDetails />} /> {/* Route for page 1 */}
                <Route exact path="/ranking-above-me" element={<RankingAboveMe />} />
                <Route exact path="/historical-data" element={<HistoricalData />} />
                <Route exact path="/transfers" element={<TransferData />} />
                <Route exact path="/rent-prices" element={<RentPrices />} />
                <Route exact path="/contact-support" element={<ContactSupport />} />
                <Route exact path="/terms-of-use" element={<TermsOfUse />} />
                <Route exact path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route exact path="/forgot-username" element={<ForgotUsername />} />
                <Route exact path="/forgot-password" element={<ForgotPassword />} />
                <Route exact path="/reset-password" element={<ResetPassword />} />
                <Route exact path="/under-construction" element={<UnderConstructionPage />} />
                <Route exact path="/historical-data-appointments" element={<HistoricalDataAppointments />} />
                <Route exact path="/non-reachable-places" element={<NonReachablePlaces />} />
                <Route exact path="/predict" element={<Predict />} />
                <Route exact path="/predict-methodology" element={<PredictMethodology />} />
                <Route exact path="/premium-upgrade" element={<PremiumUpgrade />} />
                <Route exact path="/donation-success" element={<DonationSuccess />} />
            </Routes>
            </TermsAcceptanceGate>
    );
}

function App() {
  return (
    <Router>
      <AppWithNavigate />
    </Router>
  );
}

export default App;